<template>
            <div class="product-app">
                <div class="container-fluid product-search-container">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12 offset-lg-3 col-lg-6 product-search">
                                <form @submit.prevent="InitSearch">
                                    <input type="text"
                                           v-model="searchQuery"
                                           name="product-page-search"
                                           id="product-page-search"
                                           :placeholder="translations.searchproducts"
                                           :aria-label="translations.searchproducts">
                                    <span v-if="searchQuery !== ''"
                                          @click="clearSearch"
                                          class="product-search-clear"
                                          id="product-search-clear">
                                        <span class="fas fa-times"></span>
                                    </span>
                                    <button type="submit"
                                            name="product-page-search-submit"
                                            class="btn-circle"
                                            id="product-page-search-submit">
                                        <span class="fas fa-search"></span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    
                    <div class="row"><div class="col-12"><h2>Rajaa hakutuloksia:</h2></div></div>
                    <div class="row justify-content-end">
                        <div v-if="categories && categories.length"
                             class="col-sm-6 col-lg-6 product-category selectdiv">
                            <!--
            <select v-model="currentCategory"
                    name="categories"
                    id="product-page-category-dropdown"
                    :aria-label="translations.categories">
                <option value disabled hidden>Kategoriat</option>
                <option v-for="category in categories"
                        :key="category.name"
                        :value="category.id">
                    {{category.name}}
                </option>
            </select>

            <i class="fas fa-angle-down"></i>
                -->
                            <span class="special-diet">
                                <button class="special-diet-btn"
                                        @click="categoriesVisible = !categoriesVisible; tontonsVisible = false">
                                    Rajaa kategorian perusteella <span><span class="fas fa-angle-down"></span></span>
                                </button>
                            </span>

                        </div>
                        <div class="col-sm-6 col-lg-6 special-diet">
                            <span class="special-diet">
                                <button class="special-diet-btn"
                                        v-if="specialDiet"
                                        @click="tontonsVisible = !tontonsVisible; categoriesVisible = false">
                                    Rajaa ruokavalion perusteella <span><span class="fas fa-angle-down"></span></span>
                                </button>
                            </span>

                        </div>
                        <div class="col-12 special-diet mt-2 mb-2">
                            <slide-up-down :active="categoriesVisible"
                                           :duration="500">
                                <button :class="[{ 'active': category.id == selectedCategory  }, 'category btn', 'a'+category.id]"
                                        v-for="(category, i) in categories"
                                        :key="category.name"
                                        :value="category.id"
                                        @click="selectCategory(category.id)">
                                    {{category.name}}
                                </button>
                            </slide-up-down>
                            <slide-up-down v-if="specialDiet"
                                           :active="tontonsVisible"
                                           :duration="500">
                                <div class="special-diet-filters">
                                    <button :class="[{'active': activeTontons.includes(tonton)}, 'tonton']"
                                            v-for="(tonton, i) in sortedTontons"
                                            :key="i"
                                            @click="toggleTonton(i)">
                                        {{tonton.name}}
                                    </button>
                                </div>
                            </slide-up-down>
                        </div>
                    </div>

                    <div class="row campaign-row">
                        <div class="col-sm-6 col-lg-3" v-for="(campaign, i) in campaigns" :key="i">
                            <label :class="{'campaign-label': true, [campaign.name + '-label']: true, 'campaign-inactive': !campaign.on}" @click="toggleCampaign(i)"><span><i :class="{fas: true, [campaign.icon]: true}"></i></span>{{campaign.title}}</label>
                        </div>
                    </div>

                    <div class="row erase-row">
                        <div class="col-12">
                            <button class="erase" id="erase-category" v-if="selectedCategory" @click="clearCategory()">Pyyhi kategoriat X</button>
                            <button class="erase" id="erase-campaign" v-if="allCampaigns != true" @click="clearCampaign()">Pyyhi kampanjat X</button>
                            <button class="erase" id="erase-diets" v-if="allDiets != true" @click="clearTontons()">Pyyhi ruokavaliot X</button>
                            <button class="erase" id="erase-all" v-if="selectedCategory || allCampaigns != true || allDiets != true" @click="clearAll()">Pyyhi kaikki X</button>
                        </div>
                    </div>

                    <div class="products">
                        <product-list :products="products"
                                      :campaigns="conf.campaigns"
                                      :translations="translations"
                                      :searching="searchOngoing" />
                        <b-pagination align="center"
                                      size="md"
                                      :total-rows="productCount"
                                      :per-page="productsPerPage"
                                      v-model="currentPage"
                                      :label-first-page="translations.gotofirstpage"
                                      :label-prev-page="translations.gotoprevpage"
                                      :label-next-page="translations.gotonextpage"
                                      :label-last-page="translations.gotolastpage"
                                      :label-page="translations.gotopage"
                                      v-if="products.length > 0 && pageCount > 1" />
                    </div>
                </div>
            </div>
</template>
<script>
    import ProductList from "./ProductList.vue";
    import Vue from "vue";
    import { logger } from "../logger";
    import SlideUpDown from 'vue-slide-up-down';
    import VueScrollTo from 'vue-scrollto';

    export default {
        props: {
            conf: {}
        },
        data: () => ({
            selectedCategory:"",
            products: Array,
            pageCount: 1,
            currentPage: 1,
            productCount: 0,
            productsPerPage: 12,
            apiUrl: "/api/productsv2",
            searchQuery: "",
            oldSearchQuery: "",
            categories: Array,
            currentCategory: "",
            initDone: false,
            fromPopState: false,
            dontUpdatePage: false,
            translations: Object,
            searchOngoing: false,
            tontons: [],
            tontonsVisible: false,
            categoriesVisible: false,
            specialDiet: false,
            allCampaigns: true,
            allDiets: true,
            campaigns: [
                { name: 'itsehoitolaake', title: 'Itsehoitolääke', pCode: 'i', icon: 'fa-band-aid', on: true },
                { name: 'kampanjatuote', title: 'Kampanjatuote', pCode: 'a', icon: 'fa-tag', on: true },
                { name: 'uutuustuote', title: 'Uutuustuote', pCode: 'u', icon: 'fa-star', on: true },
                { name: 'kerailytuote', title: 'Keräilytuote', pCode: 'e', icon: 'fa-shopping-basket', on: true }
            ],
        }),
        components: { ProductList, SlideUpDown },
        computed: {
            tontonString() {
                if (!this.specialDiet)
                    return "";

                let t = this.activeTontons
                    .map(t => t.name)
                    .join(",");

                if (!t.length) return "";

                return t;
            },
            activeTontons() {
                return this.tontons.filter(t => t.on);
            },
            sortedTontons() {
                const tontons = this.tontons;
                tontons.sort((a, b) => a.name.localeCompare(b.name));
                return tontons;
            },
            url() {
                var url = `${window.location.pathname}?page=${this.currentPage}`;

                if (this.searchQuery)
                    url += `&query=${this.searchQuery}`;

                if (this.tontonString !== "")
                    url += `&tonton=${this.tontonString}`;

                if (this.campaigns.some(c => !c.on))
                    url += `&campaigns=${this.campaigns.filter(c => c.on).map(c => c.pCode).join('')}`


                //if (document.getElementById("product-page-category-dropdown").value !== "") {
                //    url += "&category=" + document.getElementById("product-page-category-dropdown").value;
                //}
                if (this.selectedCategory != "") {
                    url += "&category=" + this.selectedCategory;
                }

                return url;
            }
        },
        watch: {
            currentCategory(value) {
                if (this.initDone) {
                    this.selectedCategory = value;
                    console.log(this.selectedCategory);
                    let url = this.categories.find(c => c.id === value).url;
                    if (this.currentPage !== 1) {
                        this.dontUpdatePage = true;
                        this.currentPage = 1;
                    }
                    this.FetchProducts();
                    //window.location = url;
                }
            },
            currentPage(value) {
                if (this.dontUpdatePage) {
                    this.dontUpdatePage = false;
                } else {
                    this.FetchProducts()
                        .then(() => {
                            let options = {
                                offset: -100,
                                force: true,
                            }
                            let cancelScroll = VueScrollTo.scrollTo('.products', 300, options);
                        });
                }
            }
        },
        methods: {
            clearSearch() {
                this.searchQuery = '';
                this.FetchProducts();
            },
            clearCategory() {
                this.selectedCategory = "";
                this.FetchProducts();
            },
            clearCampaign() {
                this.campaigns.forEach(c => c.on = true);
                this.allCampaigns = true;
                if (this.currentPage !== 1) {
                    this.dontUpdatePage = true;
                    this.currentPage = 1;
                }
                this.FetchProducts();
            },
            clearTontons() {
                this.tontons.forEach(c => c.on = false);
                this.allDiets = true;
                if (this.currentPage !== 1) {
                    this.dontUpdatePage = true;
                    this.currentPage = 1;
                }
                this.FetchProducts();
            },
            clearAll() {
                this.searchQuery = '';
                this.selectedCategory = "";
                this.campaigns.forEach(c => c.on = true);
                this.allCampaigns = true;
                this.tontons.forEach(c => c.on = false);
                this.allDiets = true;
                if (this.currentPage !== 1) {
                    this.dontUpdatePage = true;
                    this.currentPage = 1;
                }
                this.FetchProducts();
            },
            toggleTonton(i) {
                this.tontons[i].on = !this.tontons[i].on;
                if (this.tontons.every(c => c.on)) {
                    this.allDiets = true;
                } else {
                    this.allDiets = false;
                }
                if (this.currentPage !== 1) {
                    this.dontUpdatePage = true;
                    this.currentPage = 1;
                }
                this.FetchProducts();
            },
            toggleCampaign(i) {
                if (this.campaigns.every(c => c.on)) {
                    this.campaigns.forEach(c => c.on = false);
                    this.campaigns[i].on = true;

                } else {
                    this.campaigns[i].on = !this.campaigns[i].on;
                }
                if (!this.campaigns.some(c => c.on)) {
                    this.campaigns.forEach(c => c.on = true);
                }
                if (this.campaigns.every(c => c.on)) {
                    this.allCampaigns = true;
                    console.log("campaigns: " + this.allCampaigns);
                } else {
                    this.allCampaigns = false;
                    console.log("campaigns: " + this.allCampaigns);
                }
                if (this.currentPage !== 1) {
                    this.dontUpdatePage = true;
                    this.currentPage = 1;
                }
                this.FetchProducts();
            },
            FetchTontons() {
                return new Promise((res, rej) => {
                    fetch(this.apiUrl + "/tontons")
                        .then(res => res.json())
                        .then(tontons => {
                            this.tontons = tontons.map(x => ({
                                name: x,
                                on: this.conf.tonton ? this.conf.tonton.split(',').includes(x) : false
                            }));
                            res();
                        })
                        .catch(err => {
                            rej(err);
                        });

                })
            },
            selectCategory(value) {
                if (value == this.selectedCategory) {
                    this.selectedCategory = "";
                } else {
                    this.selectedCategory = value;
                }
                if (this.currentPage !== 1) {
                    this.dontUpdatePage = true;
                    this.currentPage = 1;
                }
                this.FetchProducts();
            },
            Init() {
                this.categories = this.conf.categories;
                this.productsPerPage = this.conf.productsPerPage || 12;
                this.translations = this.conf.translations;

                console.log("Category: " + this.conf.category);

                if (screen.width < 768)
                    this.tontonsVisible = false;

                if (this.conf.page != 0) {
                    this.dontUpdatePage = true;
                    this.currentPage = this.conf.page;
                }

                if (this.conf.category != null) {
                    this.selectedCategory = this.conf.category;
                }

                if (this.conf.search)
                    this.searchQuery = this.conf.search;

                if (this.conf.campaignParam) {
                    this.campaigns.forEach(c => c.on = false);
                    for (const letter of this.conf.campaignParam) {
                        const campaign = this.campaigns.find(c => c.pCode === letter);
                        if (campaign)
                            campaign.on = true;
                    }
                    this.allCampaigns = false;
                    if (!this.campaigns.some(c => c.on)) {
                        this.campaigns.forEach(c => c.on = true);
                        this.allCampaigns = true;
                    }
                }

                if (this.conf.specialDiet) {
                    this.specialDiet = true;
                    this.FetchTontons()
                        .finally(_ => this.FetchProducts(true));
                } else {
                    this.FetchProducts(true);
                }
            },
            FetchProducts(initial = false) {
                this.searchOngoing = true;

                let category = this.conf.pageId;
                console.log("initial category: " + category);

                //category = this.categories.find(c => c.id === value).id;
                if (document.getElementById("product-page-category-dropdown")) {
                    if (document.getElementById("product-page-category-dropdown").value !== "") {
                        category = document.getElementById("product-page-category-dropdown").value;
                        console.log("final category: " + category);
                    }
                }
                if (this.selectedCategory != "") {
                    category = this.selectedCategory; //ESA
                    console.log("Selected category: " + this.selectedCategory)
                }

                let url = `${this.apiUrl}${this.searchQuery.length ? '/search' : ''}?contentId=${category}&count=${this.productsPerPage}&page=${this.currentPage}`;

                if (this.searchQuery !== '')
                    url += '&query=' + this.searchQuery;

                if (this.specialDiet && this.tontonString !== "") {
                    url += `&tonton=${this.tontonString}`;
                }

                if (this.campaigns.some(c => !c.on)) {
                    url += `&campaigns=${this.campaigns.filter(c => c.on).map(c => c.pCode).join('')}`
                }

                console.log("search url: " + url);

                return fetch(url, {
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(model => {
                        this.products = model.Products;
                        this.pageCount = Math.ceil(model.Total / this.productsPerPage);
                        this.productCount = model.Total;
                        this.dontUpdatePage = false;
                        this.searchOngoing = false;
                        let state = this.$data;

                        if (initial) {
                            this.initDone = true;
                            history.replaceState(state, "Tuotteet", this.url);
                            logger.log("replaced state: " + this.url, state);
                        } else {
                            history.pushState(state, "Tuotteet", this.url);
                            logger.log("pushed state:" + this.url, state);
                        }

                        if (this.searchQuery.length)
                            this.oldSearchQuery = this.searchQuery;


                    })
                    .catch(err => {
                        console.error(err);
                        this.searchOngoing = false;
                    });

            },
            InitSearch() {
                this.dontUpdatePage = true;
                this.currentPage = 1;
                this.FetchProducts();
            }
        },
        mounted() {
            this.Init();

            window.onpopstate = event => {
                if (event.state) {
                    // set all properties from event.state into data
                    Object.entries(event.state).forEach(entry =>
                        Vue.set(this.$data, entry[0], entry[1])
                    );
                    this.dontUpdatePage = true;
                    logger.log("popped state: " + event.state);
                }
            };
        }
    };
</script>